import React, { useState, useEffect, useContext } from 'react'
import { ButtonName } from '../../../config/enums'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import constants from '../../../config/constants'
import { Redirect, useParams } from 'react-router'
import {
  getGiftBundles,
  getGift,
  updateGift
} from '../../../services/giftService'
import GiftForm from './giftForm'
import { VendorContext } from '../../../contexts/vendorContext'
import { GiftBundle } from '../../../models/GiftBundle'
import { Gift } from '../../../models/Gift'

const EditGift = () => {
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [giftBundlesList, setGiftBundlesList] = useState<GiftBundle[]>([])
  const [gift, setGift] = useState<Gift>()
  const vendorContext = useContext(VendorContext)
  const vendorId = vendorContext?.profile?.vendorId
  const { id } = useParams()

  useEffect(() => {
    const getBundles = async () => {
      setGiftBundlesList(await getGiftBundles(vendorId!))
    }

    getBundles()
  }, [vendorContext, vendorId])

  useEffect(() => {
    const getGiftData = async () => {
      setGift(await getGift(id!))
    }

    if (id) {
      getGiftData()
    }
  }, [id])

  const updateGiftSubmit = async (
    name: string,
    listingStatus: boolean,
    giftBundleIds: string[],
    imageUrl: string | null
  ) => {
    setIsDisabled(true)
    try {
      if (imageUrl == null) {
        toast.error(constants.alertError.noImageUploaded, { autoClose: false })
        setIsDisabled(false)
      } else {
        updateGift(id!, name, listingStatus, giftBundleIds, imageUrl!)
          .then(success => {
            if (success) {
              toast.success(constants.alertMessage.updateGiftSuccessful, {
                autoClose: 3000
              })
              setIsSuccessful(true)
            } else {
              toast.error(friendlyMessageFor(''))
            }
          })
          .catch(error => {
            setIsDisabled(false)
            toast.error(friendlyMessageFor(error), { autoClose: false })
          })
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (isSuccessful) {
    return <Redirect to="/vendor/gifts" />
  }
  return (
    <GiftForm
      formCallback={(name, listing, giftBundles, imageUrl) => {
        updateGiftSubmit(name, listing, giftBundles, imageUrl)
      }}
      isDisabled={isDisabled}
      formType={ButtonName.edit}
      name={gift?.name}
      currentImage={gift?.imageUrl}
      listingStatus={gift?.isActive}
      giftBundles={giftBundlesList}
      docId={id}
      currentGiftBundle={gift?.giftBundleIds && gift?.giftBundleIds[0]}
    />
  )
}

export default EditGift
